<template>
  <div class="hardware">
    <div class="header">
      <div class="title">物联网智能硬件</div>
      <div class="border"></div>
    </div>
    <div class="title-list">
      <div
        class="item"
        v-for="item in hardwareTitleList"
        :key="item.id"
        @mouseenter="titleTab(item.id)"
      >
        <img :src="item.logo" alt="" />
        <div :class="titleId == item.id ? 'active' : ''">{{ item.title }}</div>
      </div>
    </div>
    <div class="hardware-list">
      <div class="list">
        <div class="item" v-for="item in hardwareList" :key="item.id">
          <div class="box" v-if="titleId == item.id">
            <div class="right">
              <div class="flex">
                <div class="title">{{ item.title }}</div>
                <router-link :to="item.path">
                  <div class="more">了解更多 ></div>
                </router-link>
              </div>
              <div class="text">{{ item.text }}</div>
              <div class="right-list">
                <div
                  class="right-item"
                  v-for="it in item.rightList"
                  :key="it.id"
                >
                  <img class="logo" :src="it.logo" alt="" />
                  <div class="item-title">{{ it.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import hardwareRouter1 from "../../../assets/programme/hardwareRouter1.png";
import hardwareRouter2 from "../../../assets/programme/hardwareRouter2.png";
import hardwareRouter3 from "../../../assets/programme/hardwareRouter3.png";
import hardwareRouter4 from "../../../assets/programme/hardwareRouter4.png";
import hardwareRouter5 from "../../../assets/programme/hardwareRouter5.png";
import hardwareRouter6 from "../../../assets/programme/hardwareRouter6.png";
import hardwareRouter7 from "../../../assets/programme/hardwareRouter7.png";
import hardwareRouter8 from "../../../assets/programme/hardwareRouter8.png";

import yesLogo from "../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      titleId: 1,
      hardwareTitleList: [
        {
          id: 1,
          title: "智能门禁",
          logo: hardwareRouter1,
        },
        {
          id: 2,
          title: "智能监控",
          logo: hardwareRouter2,
        },
        {
          id: 3,
          title: "楼宇对讲",
          logo: hardwareRouter3,
        },
        {
          id: 4,
          title: "智能梯控",
          logo: hardwareRouter4,
        },
        {
          id: 5,
          title: "智能家居",
          logo: hardwareRouter5,
        },
        {
          id: 6,
          title: "智能充电",
          logo: hardwareRouter6,
        },
        {
          id: 7,
          title: "智能停车",
          logo: hardwareRouter7,
        },
        {
          id: 8,
          title: "智能能耗",
          logo: hardwareRouter8,
        },
      ],
      hardwareList: [
        {
          id: 1,
          title: "智能门禁",
          text: "多种通行方式自由选择，提高出行效率",
          path: "/mobile/programme/accesscontrol",
          rightList: [
            {
              id: 1,
              title: "一键开门",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "访客邀约",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "防夹控制",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "人脸识别",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "海量储存",
              logo: yesLogo,
            },
            {
              id: 6,
              title: "安全高效",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 2,
          title: "智能监控",
          text: "云监控 实时监控报警 全方位保驾护航",
          path: "/mobile/programme/monitor",
          rightList: [
            {
              id: 1,
              title: "360°无死角",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "视频回放",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "远程监控",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "防御报警",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "安全保障",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 3,
          title: "楼宇对讲",
          text: "集中管理 远程监控 保障居住安全的“守护神”",
          path: "/mobile/programme/intercom",
          rightList: [
            {
              id: 1,
              title: "音质好",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "安全性高",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "稳定性高",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "性能可靠",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "经济有效",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 4,
          title: "智能梯控",
          text: "多种通行方式自由选择，提高出行效率",
          path: "/mobile/programme/laddercontrol",
          rightList: [
            {
              id: 1,
              title: "设定权限",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "便捷性强",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "高校性强",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "使用数据记录",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "扩展功能",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 5,
          title: "智能家居",
          text: "通过家庭网关及其系统软件建立智能家居平台系统",
          path: "/mobile/programme/homefurnishing",
          rightList: [
            {
              id: 1,
              title: "实用便利",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "标准性",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "方便性",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "轻巧性",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 6,
          title: "智能充电",
          text: "高效、智能化的充电体验",
          path: "/mobile/programme/charge",
          rightList: [
            {
              id: 1,
              title: "自动断电",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "在线充值",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "过载保护",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "联网定位",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "充电数据分析",
              logo: yesLogo,
            },
            {
              id: 6,
              title: "实时监控",
              logo: yesLogo,
            },
            {
              id: 7,
              title: "语音提示",
              logo: yesLogo,
            },
            {
              id: 8,
              title: "多种计费",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 7,
          title: "智能停车",
          text: "智能找车位+自动缴费停车",
          path: "/mobile/programme/parking",
          rightList: [
            {
              id: 1,
              title: "快速通行",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "特殊停车位",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "错时错位停车",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 8,
          title: "智能能耗",
          text: "远程抄表 余量监控 自动计费 生成订单",
          // path: "/mobile/programme/energyconsumption",
          path: '',
          rightList: [
            {
              id: 1,
              title: "数据集中",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "节省能源",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "提前预警",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "提高效率",
              logo: yesLogo,
            },
          ],
        },
      ],
    });
  },
  methods: {
    titleTab(id) {
      this.titleId = id;
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}
.title-list {
  width: 92vw;
  margin: 24px auto 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: scroll;
}
.title-list::-webkit-scrollbar {
  display: none;
}
.title-list .item {
  text-align: center;
  cursor: pointer;
  margin-right: 24px;
}
.title-list .item img {
  width: 24px;
}
.title-list .item div {
  width: 56px;
  font-size: 14px;
  color: #2a3d50;
}
.title-list .item .active {
  color: #248efb;
  border-bottom: 4px solid #248efb;
  padding-bottom: 6px;
}
.hardware-list {
  background: linear-gradient(180deg, #eff7ff 0%, #fdfeff 100%);
  box-shadow: inset 0px 10px 20px 1px rgba(31, 81, 210, 0.06);
  padding: 16px 0;
}
.hardware-list .list {
  width: 92vw;
  margin: 0 auto;
}

.hardware-list .list .item .box .right .flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hardware-list .list .item .box .right .title {
  font-size: 14px;
  color: #2a3d50;
  font-weight: 600;
}
.hardware-list .list .item .box .right .more {
  font-size: 14px;
  color: #248EFB;
}
.hardware-list .list .item .box .right .text {
  margin-top: 13px;
  font-size: 13px;
  color: #4c6681;
}
.hardware-list .list .item .box .right .right-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.hardware-list .list .item .box .right .right-list .right-item {
  width: 115px;
  display: flex;
  align-items: center;
  margin-top: 18px;
}
.hardware-list .list .item .box .right .right-list .right-item .logo {
  width: 10px;
  margin-right: 8px;
}
.hardware-list .list .item .box .right .right-list .right-item .item-title {
  font-size: 12px;
  color: #2a3d50;
}
</style>
